import { useParams } from 'react-router-dom';
import { createRoute, useEntityUrl } from 'framework/routing';

export const CONTACTS_PATH = '/crm/contacts';

export const useContactRoute = () => {
  const baseRoutes = createRoute({ listRoute: CONTACTS_PATH });

  return {
    ...baseRoutes,
    timelineRoute: `${baseRoutes.singleEntityRoute}/notes/:timelineEntryId?`,
    relatedOpportunitiesRoute: `${baseRoutes.singleEntityRoute}/related-opportunities`,
  };
};

export const useContactUrl = () => {
  const baseUrls = useEntityUrl({ baseLink: CONTACTS_PATH });

  return {
    ...baseUrls,
    getCreateUrl: (params?: Dictionary<string>) => {
      const urlParameters = new URLSearchParams(params).toString();

      return `${baseUrls.getCreateUrl()}${urlParameters ? `?${urlParameters}` : ''}`;
    },
    getNotesUrl: (id: string) => `${baseUrls.getSingleEntityUrl(id)}/notes`,
    getRelatedOpportunitiesUrl: (id: string) => `${baseUrls.getSingleEntityUrl(id)}/related-opportunities`,
  };
};

export const useContactId = () => useParams<Dictionary<string>>().id!;
